<template>
  <div class="container">
    <div class="list" v-if="list.length > 0">
      <div class="item" v-for="(item,index) in list" :key="index">
        <div>
          <div class="title-area">
            <span class="title">{{item.ITEM_NAME}}</span>
            <div class="type green" v-if="item.isSB == 1">在保</div>
            <div class="type blue" v-else>超保</div>
          </div>
          <div class="date" v-if="(item.BEGIN_DATE && item.BEGIN_DATE!='null') && (item.END_DATE && item.END_DATE!='null')">
            <span>{{parseTime(item.BEGIN_DATE,'{y}-{m}-{d}')}} - {{parseTime(item.END_DATE,'{y}-{m}-{d}')}}</span>
          </div>
        </div>
        <div class="goto" @click="goto(item.ITEM_ID)" v-if="item.isRepair == 1">
          <span>有维修</span>
          <i class="el-icon-arrow-right" style="font-size:1.3rem;font-weight:bold"></i>
        </div>
      </div>
    </div>
    <div style="margin-top:20px" v-else>暂无三包信息</div>
  </div>
</template>

<script>
import {ShowSBInfo} from '../../apis/sanbao'
import { parseTime} from '@/utils/index'
import { Toast } from 'vant'
export default {
  name:'sanbao',
  data(){
    return {
      list:[]
    }
  },
  methods:{
    parseTime,
    goto(itemId){
      this.$router.push({
        path:'/sanbao/detail',
        query:{
          vid:this.$route.query.id,
          itemId:itemId,
          ownerId:this.$route.query.ownerId
        }
      })
    },
    _ShowSBInfo(){
      let params = {
        vId :this.$route.query.id,
        // vId:'8294687'
      }
      Toast.loading({
        duration: 0, // 持续展示 toast
         forbidClick: true,
         message: "加载中..."
      })
      ShowSBInfo(params).then(res=>{
        this.list = res.data
        Toast.clear()
      }).catch(err=>{
        console.log(err)
        Toast.clear()
      })
    }
  },
  mounted(){
    this._ShowSBInfo()
  }
}
</script>

<style lang="scss" scoped>
  .list{
    padding:0.9375rem;
    .item{
      background: #FFFFFF;
      box-shadow: 0px 2px 8px 0px rgba(255, 92, 99, 0.1);
      border-radius: 4px;
      padding:1.125rem 0.9375rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-align: left;
      margin-bottom:0.9375rem;
      .title-area{
        display: flex;
        align-items: center;
      }
      .title{
        font-size:1rem;
        color:#333;
        font-weight: bold;
        margin-right:0.625rem;
      }
      .type{
        display: inline-block;
        width:3.75rem;
        height:1.5rem;
        line-height: 1.5rem;
        font-size:0.8rem;
        text-align: center;
        border-radius: 4px;
      }
      .date{
        font-size:13px;
        color:#666;
        margin-top:0.75rem;
      }
      .goto{
        color:#999;
        font-size:13px;
        display: flex;
        align-items: center;
      }
      .green{
        background:#EBF9EF;
        color:#48CE70;
      }
      .blue{
        background:#EEF4FF;
        color:#5B92FF;
      }
    }
  }
</style>